export default "__VITE_ASSET__DdIkVakT__"